import { useState } from "react";

type Props = { question: string; answer: string };

export default function FAQItem({ question, answer }: Props) {
    const [open, setOpen] = useState(false);

    return (
        <div className="border-b py-4">
            <button onClick={() => setOpen(!open)} className="w-full text-left font-semibold flex justify-between">
                {question}
                <span>{open ? "-" : "+"}</span>
            </button>
            {open && <p className="mt-2 text-gray-600">{answer}</p>}
        </div>
    );
}
